import { render, staticRenderFns } from "./ResendCodeLink.vue?vue&type=template&id=8e9ecd0c"
import script from "./ResendCodeLink.vue?vue&type=script&lang=ts"
export * from "./ResendCodeLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports